/* eslint-disable no-undef */
/**
 * Single product
 *
 * Example: Scripts for the single product
 *
 * @since 1.0.0
 */
import $ from 'jquery'; // eslint-disable-line import/no-unresolved

export default {
  onResize() {
    this.maybeMoveLeftSide();
  },

  moveGalleryControls() {
    const controls = document.querySelector(
      '.woocommerce-product-gallery .flex-control-thumbs'
    );
    const betterHome = document.querySelector('.summary__left');

    if (controls && betterHome) {
      betterHome.insertBefore(controls, betterHome.firstChild);
    }
  },

  maybeMoveLeftSide() {
    if (window.innerWidth <= 992) {
      // Move above extended content

      const extendedContent = document.querySelector('.extended-content');
      const left = document.querySelector('.summary__left');

      extendedContent.parentElement.insertBefore(left, extendedContent);
    } else {
      // Move back to left

      const left = document.querySelector('.summary__left');
      const right = document.querySelector('.summary__right');

      right.parentElement.insertBefore(left, right);
    }
  },

  hideFloatingBar() {
    $('.floating-bar').show();
    const crossContainer = $('.crossell-container');

    if (crossContainer.length > 0) {
      const topOfOthDiv = $('.crossell-container').offset().top / 10 + 300;
      $(window).scroll(() => {
        if ($(window).scrollTop() > topOfOthDiv) {
          // scrolled past the other div?
          $('.floating-bar').fadeOut(400); // reached the desired point -- show div
        } else {
          $('.floating-bar').fadeIn(400); // else above the desired point -- hide div
        }
      });
    }
  },

  init() {
    const $jq = jQuery.noConflict();
    $jq(() => {
      $jq('.slider').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
      });
    });

    this.moveGalleryControls();
    this.maybeMoveLeftSide();
    if (window.innerWidth >= 992) {
      this.hideFloatingBar();
    }

    this.onResize = this.onResize.bind(this);

    window.addEventListener('resize', this.onResize, { passive: true });
  },

  finalize() {
    // JavaScript to be fired on the single product page, after the init JS
  },
};
